var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-toast"},[_c('div',{staticClass:"toast",class:_vm.classObject},[_c('h6',[_vm._v(_vm._s(_vm.notification.title))]),(_vm.notification.content)?_c('span',[_vm._v(_vm._s(_vm.notification.content))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }